import { render, staticRenderFns } from "./CustomerSignature.vue?vue&type=template&id=05322ccb&scoped=true&"
import script from "./CustomerSignature_.js?vue&type=script&lang=js&"
export * from "./CustomerSignature_.js?vue&type=script&lang=js&"
import style0 from "./CustomerSignature.vue?vue&type=style&index=0&id=05322ccb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05322ccb",
  null
  
)

export default component.exports